define('responsive-gameday/views/Monitor/ViewModels/distributors/ChyronDistributor',['require','exports','module','GameDayCore','message-service/message-service','../../Events/SceneStateEvents','../../Events/ViewModelUpdateEvents','../../../distributors/events/DistributionEvents','gameday-index-enums/enums/baseball/GameStates','GameDayCore/GDModel/enums/datasources/Datasources','gameday-resource-path/gameday-resource-path','extant/extant','jquery','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','gameday-index-url-hasher/UrlHasher'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        MessageService = require("message-service/message-service"),
        SceneStateEvents = require("../../Events/SceneStateEvents"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        DistEvents = require("../../../distributors/events/DistributionEvents"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        exists = require("extant/extant"),
        $ = require("jquery"),
        NumberWithOrdinal = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
        UrlHasher = require('gameday-index-url-hasher/UrlHasher');

    var gameData,
        stateUpdates,
        play,
        boxscore,
        linescore,
        players,
        gameInfo,
        battingOrder,
        dataPack,
        gameItem;

    var MODE_INNING="inning",
        MODE_MIDINNING="midInning",
        MODE_FINAL="final",
        MODE_PREGAME="pregame",
        MODE_DELAYED="delay";


    exports.setGameData = function(game, scenes) {
        dataPack = { };
        gameData = GDC.getGameData();
        stateUpdates = scenes;
        play = game.play;
        boxscore = game.boxscore;
        battingOrder = (play.inning_state === "End" || play.inning_state === "Top") ? play.awayBattingOrder : play.homeBattingOrder;
        players = game.players,
        gameInfo = game.game;
        linescore = $.extend({}, game.linescore);
        buildSendDataPack();
        MessageService.off.call(this,UpdateEvents.REQUEST_CHYRON_DATA,this.handleUpdateRequest);
        MessageService.on.call(this,UpdateEvents.REQUEST_CHYRON_DATA,this.handleUpdateRequest);
    };

    exports.handleUpdateRequest = function() {
        exports.setGameData(GDC.getGameData(),stateUpdates);
    };


    function buildSendDataPack() {
        dataPack = { };
		dataPack.play = play;

        buildTeams();
        buildLinescore();
        buildStatus();
        buildBSO();
        buildUpNext();
        buildRunners();
        buildMatchup();
        buildPitchers();


        var evt=determineEventType(play.abstractGameState);
        MessageService.publish(UpdateEvents.UPDATE_CHYRON, dataPack);

        // EN ROUTE ...
        // leaning towards the future, let's iterate thru the scene states to update subcomponents
        for (var state in stateUpdates) {
            switch(state) {
                case SceneStateEvents.COUNT_CHANGE:
                    MessageService.publish(UpdateEvents.UPDATE_CHYRON_BSO, dataPack.bso);
                    break;
            }
        }

    };

    function buildStatus() {

        dataPack.game.innings.currentTop = function () {
            return (play.inning_state === "Top") ? "active" : "";
        };

        dataPack.game.innings.currentBottom = function () {
            return (play.inning_state === "Bottom") ? "active" : "";
        };

        dataPack.game.innings.state = function() {
            return play.inning_state !== "" ? play.inning_state + " " + NumberWithOrdinal(play.inning) : play.gamestate;
        };
        dataPack.game.innings.stateShort = function() {
            return play.inning_state !== "" ? play.inning_state.substr(0,3) + " " + NumberWithOrdinal(play.inning) : play.gamestate;
        };

        dataPack.gameDelayed = (play.abstractGameState === GameStates.ABSTRACT_DELAYED) || (play.abstractGameState === GameStates.ABSTRACT_OTHER);

        if (exists(play, "challenge_status,challenging_team") && play.challenge_status.lastIndexOf("M", 0) === 0) {
            // dataPack.play.gamestate = "Delay";
            dataPack.play.gamestate = dataPack.game.innings.state();
            dataPack.play.reason = play.challenging_team + " Challenge";
        } else if (play.gamestate === "Review") {
            // dataPack.play.gamestate = "Review";
            dataPack.play.gamestate = dataPack.game.innings.state();
            dataPack.play.reason = "Ump Review";
        }

    }

    function buildTeams() {
        dataPack.home = $.extend({},gameInfo.home) || {};
        dataPack.away = $.extend({},gameInfo.away) || {};
        dataPack.teams = {
            home : dataPack.home,
            away : dataPack.away
        };

        dataPack.records = (play.state !== "Final") ? false :
                           { home: dataPack.home.records,
                             away: dataPack.away.records };
    }

    function buildMatchup() {
        if (exists(play.atbat)) {
            dataPack.matchup = {
                batter: play.atbat.getBatterModel(),
                pitcher: play.atbat.getPitcherModel(),
                deck: play.gameItem && play.gameItem.getPlayerSnapshot(play.ondeck, "b"),
                hole: play.gameItem && play.gameItem.getPlayerSnapshot(play.inhole, "b")
            };
        } else {
            /*
             * atBat file not there, build player info from players file
             */
            var playerData = GDC.getGameData("players");
            var playerMap = playerData.players.playerMap;
            dataPack.matchup = {
                batter: play.batter,
                pitcher: play.pitcher,
                deck: play.gameItem && play.gameItem.getPlayerSnapshot(play.ondeck, "b"),
                hole: play.gameItem && play.gameItem.getPlayerSnapshot(play.inhole, "b")
            };
            if (play.batter) {
                dataPack.matchup.batter.last =  playerMap[play.batter.pid].last;
                dataPack.matchup.batter.mugshot = resourcePath.get('mugshot',{ pid : play.batter.pid});
            }

            if (play.pitcher) {
                dataPack.matchup.pitcher.last =  playerMap[play.pitcher.pid].last;
                dataPack.matchup.pitcher.mugshot = resourcePath.get('mugshot',{ pid : play.pitcher.pid});
            }
        }
    }

    function buildLinescore() {
        dataPack.home.runs = boxscore.home_runs;
        dataPack.home.sport_code = boxscore.home_sport_code;

        dataPack.away.runs = boxscore.away_runs;
        dataPack.away.sport_code = boxscore.away_sport_code;

        dataPack.game = {};
        dataPack.game.linescore = boxscore.linescore;
        dataPack.game.innings = boxscore.innings;
    }

    function buildBSO() {
        dataPack.bso = {
            ball1: (play.balls >= 1) ? 'active' : '',
            ball2: (play.balls >= 2) ? 'active' : '',
            ball3: (play.balls >= 3) ? 'active' : '',
            ball4: (play.balls >= 4) ? 'active' : '',
            strike1: (play.strikes >= 1) ? 'active' : '',
            strike2: (play.strikes >= 2) ? 'active' : '',
            strike3: (play.strikes >= 3) ? 'active' : '',
            out1: (play.outs >= 1) ? 'active' : '',
            out2: (play.outs >= 2) ? 'active' : '',
            out3: (play.outs >= 3) ? 'active' : ''
        }
    }

    function buildUpNext() {
        dataPack.upnext = {
            next: play.gameItem && play.gameItem.getPlayerSnapshot(battingOrder[8], "b"),
            deck: play.gameItem && play.gameItem.getPlayerSnapshot(battingOrder[0], "b"),
            hole: play.gameItem && play.gameItem.getPlayerSnapshot(battingOrder[1], "b")
        };
    }

    function buildRunners() {
        dataPack.game.runners = {
            first: play.offense.first && play.offense.first.boxname,
            second: play.offense.second && play.offense.second.boxname,
            third: play.offense.third && play.offense.third.boxname,
            mini: {
                first: play.offense.first ? 'active' : '',
                second: play.offense.second ? 'active' : '',
                third: play.offense.third ? 'active' : ''
            }
        };
    }

    function buildPitchers() {
        var win,
            lose,
            save;
        // Need a winning and losing pitcher before redrawing.
        if(!exists(linescore.winning_pitcher,'id') || !exists(linescore.losing_pitcher,'id')) {
            dataPack.pitchingDecisions = null;
            return;
        };


        dataPack.pitchingDecisions = {
            winner: linescore.winning_pitcher,
            loser: linescore.losing_pitcher
        };

        win = players.findPlayer(dataPack.pitchingDecisions.winner.id);
        lose = players.findPlayer(dataPack.pitchingDecisions.loser.id);


        // Not every game has a save.
        if (exists(linescore, "save_pitcher.id") && linescore.save_pitcher.id != "") {
            dataPack.pitchingDecisions.save = linescore.save_pitcher;
            save = players.findPlayer(dataPack.pitchingDecisions.save.id);
        }

        if(win) {
            dataPack.pitchingDecisions.winner.mugshot = resourcePath.get('mugshot',{ pid : win.id});
            dataPack.pitchingDecisions.winner.rl = win.rl + "HP";
            dataPack.pitchingDecisions.winner.num = win.num;
            dataPack.pitchingDecisions.loser.mugshot = resourcePath.get('mugshot',{ pid : lose.id});
            dataPack.pitchingDecisions.loser.rl = lose.rl + "HP";
            dataPack.pitchingDecisions.loser.num = lose.num;
        }

        if (exists(dataPack, "pitchingDecisions.save")) {
            dataPack.pitchingDecisions.save.mugshot = resourcePath.get('mugshot',{ pid : save.id});
            dataPack.pitchingDecisions.save.rl = save.rl + "HP";
            dataPack.pitchingDecisions.save.num = save.num;
        }
    }

    function determineEventType(gamestate) {
        var evt;
        var linescoreDebug = UrlHasher.getCachedParams().ls_state;
        gamestate=linescoreDebug || gamestate;

        dataPack.renderMode={};
        switch (gamestate) {
            case GameStates.ABSTRACT_PREGAME:
                evt = UpdateEvents.UPDATE_CHYRON_PREGAME;
                dataPack.renderMode[MODE_PREGAME]=true;
                break;
            case GameStates.ABSTRACT_DELAYED:
            case GameStates.ABSTRACT_LIVE:
            case GameStates.ABSTRACT_OTHER:
                if(play.inning_state === "Middle" || play.inning_state === "End"){
                    evt = UpdateEvents.UPDATE_CHYRON_MID_INNING;
                    dataPack.renderMode[MODE_MIDINNING]=true;
                }else{
                    evt = UpdateEvents.UPDATE_CHYRON_INNING;
                    dataPack.renderMode[MODE_INNING]=true;
                }
                break;
            case GameStates.ABSTRACT_FINAL:
                evt = UpdateEvents.UPDATE_CHYRON_FINAL;
                dataPack.renderMode[MODE_FINAL]=true;
                break;
        };

        return evt;
    }

});
